module.exports = __webpack_public_path__ + "img/logo-video.d48de8fc.png";